// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3wfUD","imageUploader":"EGiftCard_imageUploader__3lu9a"};